import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["conditionRows", "variableRows", "conditionTemplate", "variableTemplate"]

  addConditionRow() {
    if (!this.hasConditionRowsTarget || !this.hasConditionTemplateTarget) {
      return
    }
    this.conditionRowsTarget.insertAdjacentHTML("beforeend", this.conditionTemplateTarget.innerHTML)
  }

  addVariableRow() {
    if (!this.hasVariableRowsTarget || !this.hasVariableTemplateTarget) {
      return
    }
    this.variableRowsTarget.insertAdjacentHTML("beforeend", this.variableTemplateTarget.innerHTML)
  }

  removeRow(event) {
    const row = event.currentTarget.closest("[data-setting-row]")
    if (!row) {
      return
    }
    row.remove()
  }
}
